<template>
  <div class="modal-card">
    <div
      class="modal-card-outside-click"
      :class="{ isMounted: isMounted }"
      @click="goBack"
    ></div>

    <div
      class="modal-card-container"
      :class="{
        isAnimating: isInteractAnimating,
        isMounted: isMounted
      }"
      :style="{ transform: transformString }"
    >
      <div class="modal-card-touch-space" ref="interactElement">
        <div class="modal-card-handle"></div>
        <div class="modal-card-actions">
          <slot name="actions"></slot>
        </div>
      </div>

      <div class="modal-card-scroll-container">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<style scoped>
h1 {
  font-size: 2.5em;
  line-height: 0.9em;
  text-align: center;
  margin: 0;
}
h2 {
  text-align: center;
  color: #777;
}

.modal-card {
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  padding: 15px;
  z-index: 100;
}

.modal-card-outside-click {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;

  transition: 0.5s;
}
.modal-card-outside-click.isMounted {
  background: rgba(0, 0, 0, 0.5);
}

.modal-card-container {
  position: relative;
  width: 400px;
  max-width: calc(100%);
  border-radius: 20px;
  padding: 30px;
  padding-top: 60px;
  background: #fff;
  box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.1);
  touch-action: none;
  z-index: 1;

  opacity: 0;
  transition: opacity 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}
.modal-card-container.isAnimating {
  transition: transform 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}
.modal-card-container.isMounted {
  opacity: 1;
}

.modal-card-touch-space {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.modal-card-scroll-container {
  position: relative;
  max-height: calc(100vh - 120px - 100px);
  overflow-x: hidden;
  overflow-y: auto;
  z-index: 2;
}
.modal-card-handle {
  position: absolute;
  left: calc(50% - 20px);
  margin-top: 27.5px;
  width: 40px;
  height: 5px;
  border-radius: 20px;
  background: #999;
}

.modal-card-actions {
  margin-top: 10px;
  margin-right: 10px;
}
/* .modal-card-actions .md-button {
  margin: 0;
  transform: scale(0.7);
} */
</style>

<script>
import { EventBus } from "../main";
import interact from "interactjs";

export default {
  name: "modal-card",
  static: {
    interactMaxRotation: 15,
    interactOutOfSightXCoordinate: 500,
    interactOutOfSightYCoordinate: 600,
    interactYThreshold: 150,
    interactXThreshold: 100
  },
  data: () => ({
    isInteractAnimating: true,
    isInteractDragged: null,
    interactPosition: {
      x: 0,
      y: 0,
      rotation: 0
    },
    isMounted: false
  }),
  methods: {
    goBack() {
      this.$router.push("/");
    },
    interactSetPosition(coordinates) {
      const { x = 0, y = 0, rotation = 0 } = coordinates;
      this.interactPosition = { x, y, rotation };
    },
    interactUnsetElement() {
      interact(this.$refs.interactElement).unset();
      this.isInteractDragged = true;
    },
    resetCardPosition() {
      this.interactSetPosition({ x: 0, y: 0, rotation: 0 });
    },
    hideCard(direction) {
      const {
        interactOutOfSightXCoordinate,
        interactOutOfSightYCoordinate,
        interactMaxRotation
      } = this.$options.static;

      this.interactUnsetElement();

      switch (direction) {
        case "RIGHT":
          this.interactSetPosition({
            x: interactOutOfSightXCoordinate,
            rotation: interactMaxRotation
          });
          break;
        case "LEFT":
          this.interactSetPosition({
            x: -interactOutOfSightXCoordinate,
            rotation: -interactMaxRotation
          });
          break;
        case "DOWN":
          this.interactSetPosition({
            y: interactOutOfSightYCoordinate
          });
          break;
      }

      this.resetCard();
    },
    resetCard() {
      this.goBack();
    }
  },
  computed: {
    transformString() {
      if (!this.isInteractAnimating || this.isInteractDragged) {
        const { x, y, rotation } = this.interactPosition;
        return `translate3D(${x}px, ${y}px, 0) rotate(${rotation}deg)`;
      }

      if (!this.isMounted) {
        let y = 100;
        return `translate3D(-50px, ${y}px, 0) rotate(10deg)`;
      }

      return null;
    }
  },
  mounted() {
    const element = this.$refs.interactElement;

    interact(element).draggable({
      onstart: () => {
        this.isInteractAnimating = false;
      },
      onmove: event => {
        const {
          interactMaxRotation,
          interactXThreshold
        } = this.$options.static;
        const x = this.interactPosition.x + event.dx;
        const y = this.interactPosition.y + event.dy;

        let rotation = interactMaxRotation * (x / interactXThreshold);

        if (rotation > interactMaxRotation) rotation = interactMaxRotation;
        else if (rotation < -interactMaxRotation)
          rotation = -interactMaxRotation;

        this.interactSetPosition({ x, y, rotation });
      },
      onend: () => {
        const { x, y } = this.interactPosition;
        const { interactXThreshold, interactYThreshold } = this.$options.static;
        this.isInteractAnimating = true;

        if (x > interactXThreshold) this.hideCard("RIGHT");
        else if (x < -interactXThreshold) this.hideCard("LEFT");
        else if (y > interactYThreshold) this.hideCard("DOWN");
        else this.resetCardPosition();
      }
    });

    this.isInteractAnimating = true;
    setTimeout(() => {
      this.isMounted = true;
    }, 300);
  },
  beforeDestroy() {
    interact(this.$refs.interactElement).unset();
  }
};
</script>
